import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'


export const singleProject = {
  data() {
    return {
      project: '',
    }
  },
  computed: {
    ...mapState({
      singleProject: state => state.projects.singleProject
    }),
    permissionCheck() {
      return this.project.permission_level
    },
  },
  watch: {
    $route(val) {
      this.findProject();
    },
    singleProject(val) {
      if (val) {
        this.findProject()
      }
    }
  },
  methods: {
    findProject() {
      const route = this.$route;
      if (this.singleProject) {
        if (route.name.includes('projectItem')) {
          const findItem = (project) => {
            let itemProjectFind;
            find(project);

            function find(project) {
              for (let item of project.items) {
                if (item.id == route.params.item) {
                  itemProjectFind = item;
                  return
                } else {
                  find(item)
                }
              };
            };
            return itemProjectFind;
          };
          this.project = findItem(this.singleProject);

        } else {
          this.project = {
            ...this.singleProject
          }
        }
      }
    },

  },
  mounted() {
    this.findProject();
  }
};
